import $ from 'jquery';
import PhotoSwipe from 'photoswipe';
import PhotoSwipeUI_Default from 'photoswipe/dist/photoswipe-ui-default';

function sleep(delay) {
  var start = new Date().getTime();
  while (new Date().getTime() < start + delay);
}

function loadGalleryImageData() {
  const pageUrl = window.location.href.split(location.search||location.hash||/[?#]/)[0];
  const lastSegment = pageUrl.substr(pageUrl.lastIndexOf('/') + 1);
  if (!lastSegment) {
    return
  }
  const galleriesUrl = `/pages/${lastSegment}/galleries.json`;
  window.loadGalleriesPromise = $.get(galleriesUrl);
  window.loadGalleriesPromise.then((response) => {
    if (response.data && response.data[0]) {
      window.galleries = response.data[0].galleries;
    }
  });
}

function setupGalleryClickHandlers(container) {
  $('.photoswipe-link').click((e) => {
      e.preventDefault();
      const link = $(e.target).closest('a');
      const galleryName = link.data('gallery-name');
      window.loadGalleriesPromise.then(() => {
        const items = window.galleries[galleryName];
        if (items) {
          openPhotoSwipe(container, items, galleryName, 0);
        }
      });
  });

  $('.photoswipe-button').click((e) => {
      const button = $(e.target).closest('button');
      const galleryName = button.data('gallery-name');
      window.loadGalleriesPromise.then(() => {
        const items = window.galleries[galleryName];
        if (items) {
          openPhotoSwipe(container, items, galleryName, 0);
        }
      });
  });
}

function checkAndOpenGalleryFromUrl(container) {
  var hashData = photoswipeParseHash();
  if(hashData.pid && hashData.gid) {
    const pid = parseInt(hashData.pid);
    const galleryName = decodeURI(hashData.gid);
    window.loadGalleriesPromise.then(() => {
      const items = window.galleries[galleryName];
      openPhotoSwipe(container, items, galleryName, pid);
    });
  }
}

function photoswipeParseHash() {
  var hash = window.location.hash.substring(1),
  params = {};

  if(hash.length < 5) {
      return params;
  }

  var vars = hash.split('&');
  for (var i = 0; i < vars.length; i++) {
      if(!vars[i]) {
          continue;
      }
      var pair = vars[i].split('=');
      if(pair.length < 2) {
          continue;
      }
      params[pair[0]] = pair[1];
  }
  return params;
}

function capSet() {
    const IMG_BORDER_RIGHT = 18;
    const pswp = window.pswp;
    const currItem = pswp.currItem;
    const title = currItem.title;

    $('.caption-custom').css({
      opacity: 0
    });

    let captionCenter = $('.pswp__caption__center');

    let img = null;
    const currImageSelector = `img[src="${currItem.src}"]`;
    let imgs = $(currImageSelector);
    if (imgs.length > 0) {
      img = imgs.first();
    }

    if (!img) {
      $('.caption-custom').remove();
      setTimeout(() => {
        capSet();
        pswp.updateSize(true);
      }, 0);
      return;
    }

    const imgRect = img.get(0).getBoundingClientRect();
    const width = imgRect.width - IMG_BORDER_RIGHT;
    captionCenter.css({
      width: `${width}px`,
      opacity: 0
    });
    captionCenter.width(width);

    let customCaption = null;
    let customCaptions = $('.caption-custom');
    if (customCaptions.length > 0) {
      customCaption = customCaptions.first();
    } else {
      const pswp_ui = $('.pswp__ui').first();
      customCaption = $(`<div class="caption-custom"></div>`);
      customCaption.appendTo(pswp_ui);
    }
    customCaption.html(title);
    customCaption.css({
        left: `${imgRect.left}px`,
        top: `${imgRect.bottom}px`,
        width: `${width}px`,
        opacity: 1
      });
    customCaption.width(width);
    const height = customCaption.height();
    let fontSize = 1;
    let lineHeight = 1.5;
    if (height > 50) {
      fontSize = 0.9;
      lineHeight = 1.25
    }
    customCaption.css({
      'font-size': `${fontSize}em`,
      'line-height': lineHeight
    });
}

function debugMsg(msg) {
  console.log(msg);
}

function openPhotoSwipe(container, items, galleryName, pid) {
    var options = {
      galleryUID: galleryName,
      index: pid - 1,
      bgOpacity: 1,
      closeOnScroll: false,
      closeOnVerticalDrag: false,
      closeElClasses: [],
      arrowEl: true,
      captionEl: true,
      clickToCloseNonZoomable: false
    }
    window.pswp = new PhotoSwipe(container, PhotoSwipeUI_Default, items, options)
    window.pswp.init()
    let pswp = window.pswp
    if (pswp.likelyTouchDevice) {
      // touch device, don't change caption
      return true;
    }

    setTimeout(() => {
      console.log('capSet and updateSize');
      capSet();
      pswp.updateSize(true);
    }, 500);


    pswp.listen('afterChange', function() {
        console.log('afterChange');
        capSet();
        pswp.updateSize(true);
    });

    pswp.listen('resize', function() {
        console.log('resize');
        capSet();
    });

    pswp.listen('imageLoadComplete', function(index, item) {
      console.log('imageLoadComplete');
      capSet();
      pswp.updateSize(true);
    });
}

$(() => {
    loadGalleryImageData();
    const container = document.querySelectorAll('.pswp')[0];
    if (container) {
      setupGalleryClickHandlers(container);
      checkAndOpenGalleryFromUrl(container);
    }
});
